'use client';

import React from 'react';
import { Dashboard } from '../../dashboard/dashboard-page';
import { IRootUser } from '../../../common';

interface IStartPageProps extends IRootUser {}

export const StartPage = (props: IStartPageProps) => {
  return (
    <div className={'min-h-screen w-full bg-lightGrey p-0'}>
      <Dashboard isAdmin={props.isAdmin} />
    </div>
  );
};

export default StartPage;
